/** @jsxImportSource @emotion/react */
import { useRouterStore } from 'mobx-state-router';
import React from 'react';

import { Alert, Header, Page } from 'src/common/ui/components';
import { ProviderForm } from 'src/components/pages/providers/Provider.Form';

export const ProviderEditPage = () => {
  const routerStore = useRouterStore();
  const { id } = routerStore.routerState.params;

  return (
    <Page>
      <Header>Edit Provider</Header>
      {id ? <ProviderForm id={id} /> : <Alert severity="error" message="No provider ID provided" />}
    </Page>
  );
};
